import { useState } from 'react';

import SalarySlip from '../salary/SalarySlip'
export default function GenpayslipPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="GenpayslipPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
            </div>
            <div className="col-12 comp-grid" >
                <div className="">
                    <SalarySlip/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
